import { useMe } from '../hooks/useMe.js';
import { API_MODE } from '../api/client.js';
import { Icon } from '../icons/Icon.js';

/** 顶栏右侧：剩余额度。mock 模式不显示（演示无意义）。 */
export function CreditsChip() {
  const { me } = useMe();
  if (API_MODE !== 'real' || !me) return null;
  const low = me.credits <= 1;
  return (
    <span className={'credits-chip' + (low ? ' low' : '')} title="剩余生成额度（1 额度 = 1 条视频）">
      <Icon name="video" size={14} />
      {me.credits}
    </span>
  );
}
